<app-component-page-header></app-component-page-header>
<ng-container *ngIf="lessonObservable | async; let lesson">
  <app-lesson-nav [lesson]="lesson"></app-lesson-nav>
  <mat-card class="mt-4">
    <app-article-header>
      <mat-card-title>
        <span class="lesson-name">{{ lesson.name }}</span>
        <button mat-icon-button class="float-right p-relative" (click)="onEdit()" *appAuthorize="[lesson.owner, 'isContentManager']">
          <mat-icon class="color-gray">edit</mat-icon>
        </button>
        <app-lesson-remove-button [lecture]="lectureObservable | async" [lesson]="lesson" *appAuthorize="lesson.owner">
          <button mat-icon-button class="float-right p-relative">
            <mat-icon class="color-gray">delete</mat-icon>
          </button>
        </app-lesson-remove-button>
      </mat-card-title>
    </app-article-header>
    <app-article-content class="py-3">
      <div class="markdown-body" (dblclick)="clicked($event)" [innerHTML]="lesson.content | markdown"></div>
    </app-article-content>
  </mat-card>
</ng-container>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lessons/lesson/lesson.component.html